(function () {
    'use strict';

    angular.module('ShargoApp')
		.filter('displayHistoryAddress', function() {
			return function(address) {
				if (address.comments === undefined || address.comments == "") {
					return address.address;
				}else{
					return address.address + ", " + address.comments;
				}
			};
		})

    angular.module('ShargoApp')
        .directive('mdDatepickerAutoWidth', function ($document) {
            return {
                restrict: 'A',
                require: 'mdDatepicker',
                link: function (scope, element, attributes, DatePickerCtrl) {
                    var itemId = "#" + attributes.id;
                    var findResults = angular.element(document.querySelector(itemId));
                    if(findResults && findResults.length > 0) {
                        var datepicker = findResults[0];
                        $document.on("click touchstart", itemId, function(ev) {
                            //ev.preventDefault();
                            var parentId = "#" + $(this).parent().attr('id');
                            var paneId = "#" + DatePickerCtrl.calendarPane.id;
                            var paneElement = angular.element(document.querySelector(paneId));
                            console.log("datepicker click id:",paneId);
                            paneElement.detach().appendTo(parentId);
                            var newStyle = {
                                "width": "100%",
                                "top": "0px",
                                "left": "0px"
                            };
                            paneElement.css(newStyle);
                        });
                    }
                }
            };
        });

    angular.module('ShargoApp')
        .directive('focusMe', ['$timeout', function ($timeout) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    scope.$watch(attrs.focusMe, function (newValue) {
                        if (newValue) {
                            $timeout(function () {
                                element[0].focus();
                            }, 100);
                        }
                    });
                    element.bind("blur", function (e) {
                        $timeout(function () {
                            scope.$apply(attrs.focusMe + "=false");
                        }, 10);
                    }); 
                    element.bind("focus", function (e) {
                        $timeout(function () {
                            scope.$apply(attrs.focusMe + "=true");
                        }, 10);
                    });
                }
            };
        }]);

        angular.module( 'ShargoApp')
            .run( function( $rootScope, $timeout ) {
                $rootScope.mouseover = false;
                // TODO: Check if it's deprecated
                $rootScope.focusInput= function($event) {
                    angular.element($event.target).parent().find('.saved-address').addClass('input_focus');
                    angular.element($event.target).parent().parent().siblings().addClass('input_focused');
                };
                // TODO: Check if it's deprecated
                $rootScope.blurInput= function($event) {
                    angular.element($event.target).parent().find('.saved-addr').removeClass('input_focus');
                    angular.element($event.target).parent().parent().siblings().removeClass('input_focused');
                };
            });

    angular.module('ShargoApp')

        .service('deliveryManagerService', function($http, $q, Configuration) {

            var svc = {};

            svc.getSearchHistory = function() {
                var deferred = $q.defer();
                $http.get(Configuration.apiUrl + '/senders/searchHistory', {
                    headers: {
                        'x-token': localStorage.getItem('xtoken'),
                        'x-userid': localStorage.getItem('userid')
                    }
                }).then(function(res) {
                    if(res.status == "200") {
                        if (res.data.city === "Barcelona") {
                            res.data.city = "BCN";
                        }
                        else if (res.data.city === "Madrid") {
                            res.data.city = "MAD";
                        }
                        else if (res.data.city === "Sant Cugat del Vallès") {
                            res.data.city = "SCV";
                        }
                        else {
                            res.data.city = "SPAIN";
                        }
                        deferred.resolve(res.data);
                    } else {
                        deferred.reject(res);
                    }
                });
                return deferred.promise;
            };

            return svc;
        });

    /*
     * Send Package Controller
     */

    angular.module('ShargoApp')

        .controller('SendPackageController', function ($scope, $rootScope, $window, $http, $location, $q, $cookies, $filter, $timeout, $anchorScroll, _, AUTH_EVENTS, AuthService, Configuration, boundariesByZone, toolsService, Analytics, deliveryManagerService) {
			$rootScope.pageConfiguration = {
				footer: true,
				header: {
					solid: -1000,
					background: 'linear-gradient(to bottom, #fed256, #ffbd4d)',
					preheader: false,
					headerLink: $rootScope.url('home'),
					headerLogo: $rootScope.device.isDesktop ? Configuration.siteDomain + "/img/header/shargo-white.svg" : Configuration.siteDomain + "/img/header/shargo-mobile.svg",
					logIn: true,
					dashboard: true,
					callToAction: {
						link: $rootScope.device.isDesktop ? $rootScope.url('sendpackage') : $rootScope.url('contact'),
						text: $rootScope.device.isDesktop ? 'header.ask4Shargo' : 'header.contact',
						target: '',
						hide: false,
						disabled: true
					},
					profile: true
				}
			};

            /*  --COMMON--  */
            // VARIABLES
            var previous = {
                phone: "",
                number: "",
                date: "",
                cvv: ""
            };
            $scope.formError = false;
            $scope.formErrorText = "";


            //FUNCTIONS
            function generateError(message) {
                $scope.formError = true;
                $rootScope.blur.errorPopUpSendPackage = true;
                angular.element(".error-pop-up").css("display", "flex");
                $scope.formErrorText = message;
            }

            function hideErrorPopUp() {
                $scope.formError = false;
                $rootScope.blur.errorPopUpSendPackage = false;
            }


            //EXECUTION
            $scope.hideErrorPopUp = hideErrorPopUp;



            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




            /*  --FORM--  */
            // VARAIBLES
            var map, geocoder, directionsService;
            var latitude = boundariesByZone["SPAIN"].center[0], longitude = boundariesByZone["SPAIN"].center[1];
            var markers = {
                origin: "",
                destiny: ""
            };
            var emptyAddress = {
                "addressView": undefined,
                "address": "",
                "latitude": "",
                "longitude": "",
                "comments": ""
            };
            $scope.autocompleteOptions = {};
            $scope.searchHistory = {};
            $scope.selectedPickup = {};
            $scope.nestedAddresses = [];

            $scope.errorsForm = {
                selectedPickup: {
                    addressView: false
                },
                nestedAddresses: [{}]
            };
            $scope.advicesForm = {
                nestedAddresses: [{}]
            };
            $scope.focusesForm = {
                selectedPickup: {
                    addressView: false
                },
                nestedAddresses: [{}]
            };
            $scope.mouseForm = {
                nestedAddresses: [
                    {mouseover: false}
                ]
            };
            // manages history visibility
            $scope.pickupShowHistory = false;
            $scope.fieldsForm = {
                nestedAddresses: [
                    {showHistory: false}
                ]
            };

            $scope.calculateSent = false;
            $scope.calculateDisableButton = false;

            // FUNCTIONS
            function getSearchHistory() {
                var deferred = $q.defer();
                if (AuthService.isAuthenticated()) {
                    deliveryManagerService.getSearchHistory().then(function (shRes) {
                        if (!shRes.city) {
                            shRes.city = "SPAIN";
                        }

                        var boundbox = new google.maps.LatLngBounds();
                        boundariesByZone[shRes.city].boundaries.forEach(function (point) {
                            boundbox.extend(new google.maps.LatLng(point[0], point[1]));
                        });
                        latitude = boundariesByZone[shRes.city].center[0];
                        longitude = boundariesByZone[shRes.city].center[1];

                        $scope.autocompleteOptions = {
                            bounds: boundbox,
                            types: ['geocode', 'establishment'],
                            componentRestrictions: {country: "es"}
                        };

                        if ($scope.selectedPickup.adr === undefined) {
                            if (shRes.lastPickUpLocations.length > 0) {
                                selectAddress(shRes.lastPickUpLocations[0], 'selectedPickup');
                            }
                        }

                        $scope.searchHistory = shRes;

                        deferred.resolve();
                    }, getSearchHistoryError(deferred));
                }
                else {
                    getSearchHistoryError(deferred);
                }
                return deferred.promise;
            }

            function getSearchHistoryError(deferred) {
                var boundbox = new google.maps.LatLngBounds();
                boundariesByZone["SPAIN"].boundaries.forEach(function (point) {
                    boundbox.extend(new google.maps.LatLng(point[0], point[1]));
                });

                $scope.autocompleteOptions = {
                    bounds: boundbox,
                    types: ['geocode', 'establishment'],
                    componentRestrictions: {country: "es"}
                };

                deferred.resolve();
            }

            function delayedMouseOver(idx) {
                $timeout(function () {
                    if (idx !== undefined) {
                        $scope.mouseForm.nestedAddresses[idx].mouseover = false;
                        $scope.fieldsForm.nestedAddresses[idx].showHistory = false;
                        updatePackageMap('destination', idx);
                    } else {
                        $scope.mouseover = false;
                        $scope.pickupShowHistory = false;
                        updatePackageMap('origin');
                    }
                }, 300);
            }

            function removeMarker(type, idx) {
                var markerKey = (!isNaN(parseFloat(idx))) ? type + '-' + idx : type;
                if (!toolsService.isEmpty(markers[markerKey])) {
                    markers[markerKey].setMap(null);
                    delete markers[markerKey];
                }
            }

            function addEmptyNestedAddress() {
                $scope.nestedAddresses.push(_.clone(emptyAddress));
                $scope.focusesForm.nestedAddresses.push({});
                $scope.errorsForm.nestedAddresses.push({});
                $scope.advicesForm.nestedAddresses.push({});
            }

            function deleteNestedAddress(idx) {
                removeMarker('destination', idx);
                $scope.nestedAddresses.splice(idx, 1);
                $scope.focusesForm.nestedAddresses.splice(idx, 1);
                $scope.errorsForm.nestedAddresses.splice(idx, 1);
                $scope.advicesForm.nestedAddresses.splice(idx, 1);
            }

            // if currentIdx is present, we only check that address
            function validateDeliveriesAddress(currentIdx) {
                var adrArrayKey = 'nestedAddresses';
                var areValidAddresses = true;
                var base = 0;
                var upperLimit = $scope[adrArrayKey].length;
                if (currentIdx !== undefined) {
                    base = currentIdx;
                    upperLimit = ($scope[adrArrayKey].length && currentIdx + 1);
                }
                // nested addresses
                for (var idx = base; idx < upperLimit; idx++) {
                    var nestedAdr = $scope[adrArrayKey][idx];

                    areValidAddresses = !toolsService.isEmpty(nestedAdr) && (!toolsService.isEmpty(nestedAdr.addressView) || !toolsService.isEmpty(nestedAdr.adr));

                    if (toolsService.isEmpty(nestedAdr)) {
                        areValidAddresses = false;
                    }
                }
                return areValidAddresses;
            }

            function gmapsComponentExists(adr, key) {
                var componentExists = false;
                if (isGMapsAutocomplete(adr.addressView)) {
                    var components = adr.addressView.address_components;
                    components.forEach(function (c) {
                        if (c.types.indexOf(key) > -1) {
                            componentExists = true;
                        }
                    });
                }
                return componentExists;
            }

            function isGMapsAutocomplete(adr) {
                console.log("TEST isGMapsAutocomplete", adr);
                return (!toolsService.isEmpty(adr) && !toolsService.isEmpty(adr.extra_description) && !toolsService.isEmpty(adr.address_components) && !toolsService.isEmpty(adr.geometry));
            }

            function checkPhone(index) {
                if (!/^[0-9]*$/.test($scope.nestedAddresses[index].personPhone)) {
                    $scope.nestedAddresses[index].personPhone = previous.phone;
                }
                else {
                    previous.phone = $scope.nestedAddresses[index].personPhone;
                }
            }

            function validatePickupAddress() {
                return !toolsService.isEmpty($scope.selectedPickup) && (!toolsService.isEmpty($scope.selectedPickup.addressView) || !toolsService.isEmpty($scope.selectedPickup.adr));
            }

            function checkSameAddress(idx) {
                if (idx !== undefined) {
                    $scope.nestedAddresses[idx].adr = undefined;
                    removeMarker('destination', idx);

                    updatePackageMap('destination', idx);
                    $scope.fieldsForm.nestedAddresses[idx].showHistory = false;
                } else {
                    $scope.selectedPickup.adr = undefined;
                    removeMarker('origin');

                    updatePackageMap('origin');
                    $scope.pickupShowHistory = false;
                }
            }

            function isValidDeliverySetField(destinationSet, key, fn) {
                var isValid = true;
                for (var i = 0; i < destinationSet.length; i++) {
                    var dSet = destinationSet[i];
                    var simpleTest = fn(((key && key !== '') ? dSet[key] : dSet));
                    $scope.errorsForm.nestedAddresses[i][key] = !simpleTest;
                    isValid &= simpleTest;
                }
                return isValid;
            }

            function areValidAddressCoords(adr) {
                return adr && adr.latitude && adr.longitude;
            }

            function itExists(a) {
                return !toolsService.isEmpty(a);
            }

            function isValidPhone(p) {
                return !toolsService.isEmpty(p) && p.length >= 9;
            }

            function isThereAnyError() {
                var result = false;
                $scope.errorsForm.nestedAddresses.forEach(function (na) {
                    var nestedKeys = Object.keys(na);
                    nestedKeys.forEach(function (nk) {
                        if (na[nk]) {
                            result = true;
                        }
                    });
                });
                return result || $scope.pickupError;
            }

            function calculate() {
                $scope.calculateDisableButton = true;
                $anchorScroll();
                // Error handling //
                $scope.formErrorText = "";
                if (!AuthService.isAuthenticated()) {
                    $scope.calculateDisableButton = false;
                    showLoginDialog();
                    return;
                }

                if (!areValidAddressCoords($scope.selectedPickup.adr)) {
                    $scope.pickupError = true;
                }

                if (!$scope.pickDate instanceof Date) {
                    generateError("La fecha introducida no es válida");
                }

                isValidDeliverySetField($scope.nestedAddresses, 'adr', areValidAddressCoords);
                isValidDeliverySetField($scope.nestedAddresses, 'personName', itExists);
                isValidDeliverySetField($scope.nestedAddresses, 'personPhone', isValidPhone);

                if (isThereAnyError()) {
                    $scope.calculateDisableButton = false;
                    return;
                }

                var destBundle = [];
                $scope.nestedAddresses.forEach(function (nested) {
                    var dBundle = {
                        dropoffLocation: nested.adr,
                        receptorName: nested.personName,
                        receptorPhone: nested.personPhone,
                        numPackages: nested.numPackages,
                        clientId: nested.clientId
                    };
                    dBundle.dropoffLocation.comments = nested.comments;
                    destBundle.push(dBundle);
                });

                $scope.formError = false;
                $scope.pickupError = false;
                $scope.pickupAdvice = false;
                $scope.promotion = null;
                $scope.showPromotion = false;
                $scope.rainingFactor = 0;

                if ($scope.selectedHour != 0) {
                    $scope.pickDate.setHours(Math.floor($scope.selectedHour / 4));
                    $scope.pickDate.setMinutes(($scope.selectedHour % 4) * 15);
                    $scope.orderDate = $scope.pickDate.getTime();
                }

                var requestBundle = {
                    pickupLocation: $scope.selectedPickup.adr,
                    destinations: destBundle,
                    orderDate: $scope.orderDate
                };
                requestBundle.pickupLocation.comments = $scope.selectedPickup.comments;

                // THIS HAS TO BE DISABLED ONLY ON DEVELOP BRANCH
                //Analytics.trackEvent('dashboard', 'click', 'calculate', 5);

                $http.post(Configuration.apiUrl + '/v1/senders/delivers/fareEstimate', requestBundle, {
                    headers: {
                        'x-token': localStorage.getItem('xtoken'),
                        'x-userid': localStorage.getItem('userid')
                    }
                }).then(function successCallback(response) {

                    $scope.formError = false;
                    var data = response.data;
                    console.log("DATA", data);
                    $scope.isWhitelist = data.whitelist == 1;
                    if ($scope.isWhitelist) $scope.showCreditCards = false;
                    $scope.senderPrice = data.senderPrice;
                    $scope.totalPrice = data.totalPrice;
                    if (data.isRouting) {
                        $scope.isRouting = 1;
                    } else {
                        $scope.isRouting = 0
                    }

                    if (data.promotion) $scope.promotion = data.promotion;
                    if (data.rainingFactor) $scope.rainingFactor = data.rainingFactor;
                    if (data.remainingBalances) $scope.remainingBalances = data.remainingBalances;
                    if (data.balancesDiscounts) $scope.balancesDiscounts = data.balancesDiscounts;
                    generateHourText($scope.selectedHour);
                    $scope.calculateSent = true;
                    if ($scope.senderPrice["bike"] != null) {
                        $scope.updateTrans("bike");
                    } else if ($scope.senderPrice["moto"] != null) {
                         $scope.updateTrans("moto");
                    } else {
                       $scope.updateTrans("car");
                    }
                    $scope.showPromotion = (!toolsService.isEmpty($scope.promotion) && ($scope.promotion.type == 1 || $scope.promotion.type == 2 || $scope.promotion.type == 3));
                    if ($scope.promotion) {
                        getPromotionTextFormatted();
                    }
                }, function errorCallback(err) {
                    if (!err.data) {
                        generateError("common.fatal-error");
                    }
                    else {
                        generateError(err.data.message);
                    }
                    $scope.calculateDisableButton = false;
                });
            }

            function generateHourText(hour) {
                var pickupSoon = $filter('translate')('pickup-soon');
                var pickupAt = $filter('translate')('pickup-at');
                console.log("Format hour text");
                if (hour == 0) $scope.hourText = pickupSoon;
                else {
                    var minutes = (hour % 4) * 15;
                    if (minutes == 0) {
                        minutes = "00";
                    }
                    var hours = Math.floor(hour / 4) + 1;
                    $scope.hourText = pickupAt + hours + ":" + minutes;
                }
            }

            function generateDatePickers() {
                $scope.myDate = new Date();
                $scope.hours = [];
                $scope.myHour = $scope.myDate.getHours();
                $scope.myMinutes = $scope.myDate.getMinutes();
                var asPossible = $filter('translate')('common.as-possible-30');//.then(function(trans) {
                if ($scope.myHour >= 23) {
                    $scope.myDate.setDate($scope.myDate.getDate() + 1);
                    $scope.myDate.setHours(7);
                    $scope.myDate.setMinutes(30);
                    $scope.myHour = 7;
                    $scope.myMinutes = 30;
                } else if ($scope.myHour < 7) {
                    $scope.hours.push({number: 8 * 4, hour: asPossible});
                    $scope.myDate.setHours(7);
                    $scope.myHour = 7;
                    $scope.myMinutes = 30;
                } else {
                    $scope.hours.push({number: 0, hour: asPossible});
                    if ($scope.myDate.getMinutes() > 30) {
                        $scope.myHour++;
                        $scope.myMinutes = $scope.myMinutes - 30;
                    } else {
                        $scope.myMinutes = $scope.myMinutes + 30;
                    }
                }

                for (var i = $scope.myHour; i <= 23; i++) {
                    for (var j = 0; j < 4; j++) {
                        var number = j * 15;

                        // 23:30 maximum time
                        if(i == 23 && number == 45) {
                            break;
                        }

                        if (i != $scope.myHour || (i == $scope.myHour && (number >= $scope.myMinutes && $scope.myDate.getHours() >= 7) || ($scope.myDate.getHours() < 7 && number >= 30))) {
                            if (number == 0) {
                                number = "00";
                            }
                            if (i<10) {
                                $scope.hours.push({number: i * 4 + j, hour: "0" + i + ":" + number});
                            } else {
                                $scope.hours.push({number: i * 4 + j, hour: i + ":" + number});
                            }
                        }
                    }
                }

                $scope.selectedHour = $scope.hours[0].number;
                $scope.minDate = new Date(
                    $scope.myDate.getFullYear(),
                    $scope.myDate.getMonth(),
                    $scope.myDate.getDate());

                $scope.myDate = new Date();
                $scope.maxDate = new Date(
                    $scope.myDate.getFullYear(),
                    $scope.myDate.getMonth(),
                    $scope.myDate.getDate() + 7);
                $scope.pickDate = $scope.minDate;
            }

            function updateHourList() {
                $scope.calculateSent = false;
                $scope.formError = false;
                $scope.hours.length = 0;
                $scope.tmpDate = new Date();
                $scope.tmpHour = $scope.tmpDate.getHours();
                if ($scope.tmpDate.setHours(0, 0, 0, 0) == $scope.pickDate.setHours(0, 0, 0, 0)) {
                    generateDatePickers();
                    return;
                }

                for (var i = 7; i <= 23; i++) {
                    for (var j = 0; j < 4; j++) {
                        var number = j * 15;

                        // 23:30 maximum time
                        if (i == 23 && number == 45) {
                            break;
                        }
  
                        // 07:30 minimum time
                        if (i == 7 && number < 30) {
                        continue;
                        }

                        if (number == 0) {
                            number = "00";
                        }
                        if (i<10) {
                            $scope.hours.push({number: i * 4 + j, hour: "0" + i + ":" + number});
                        } else {
                            $scope.hours.push({number: i * 4 + j, hour: i + ":" + number});
                        }
                    }
                }
                $scope.selectedHour = $scope.hours[0].number;
            }

            function generateMap() {
                if (window.google) {
                    geocoder = new google.maps.Geocoder();
                    directionsService = new google.maps.DirectionsService();
                    var latlng = new google.maps.LatLng(latitude, longitude);
                    var setZoom = 5;
                    if ($scope.searchHistory && $scope.searchHistory.city) {
                        setZoom = boundariesByZone[$scope.searchHistory.city].zoom;
                    }
                    var mapOptions = {
                        zoom: setZoom,
                        center: latlng,
                        navigationControl: false,
                        mapTypeControl: false,
                        scaleControl: false,
                        draggable: true
                    };
                    map = new google.maps.Map(document.getElementById("map-send"), mapOptions);
                } else {
                    generateError("No se ha podido cargar Google Maps");
                }
            }

            function geocodePromise(request) {
                var deferredGeocode = $q.defer();
                geocoder.geocode(request, function (results, status) {

                    if (status == google.maps.GeocoderStatus.OK) {
                        deferredGeocode.resolve(results);
                    } else {
                        deferredGeocode.reject(status);
                    }
                });
                return deferredGeocode.promise;
            }

            function generateAddressFromComponents(adr) {
                var address = {};
                address.address = adr.extra_description;
                return address;
            }

            function upsertMarker(coordinates, type, idx) {
                var location = new google.maps.LatLng(coordinates[1], coordinates[0]);

                var markerKey = (!isNaN(parseFloat(idx))) ? type + '-' + idx : type;
                // case new creation
                if (!markers[markerKey]) {
                    markers[markerKey] = new google.maps.Marker({
                        map: map,
                        position: location,
                        optimized: false,
                        icon: {
                            url: ((type === "origin") ? "./img/svg/map-delivery-black.svg" : "./img/svg/map-placemark-black.svg"),
                            size: new google.maps.Size(50, 50),
                            scaledSize: new google.maps.Size(50, 50),
                            origin: new google.maps.Point(0, 0),
                            anchor: new google.maps.Point(0, 50)
                        }
                    });

                    // moving existing marker
                } else {
                    markers[markerKey].setPosition(location);
                    markers[markerKey].setMap(map);
                }

                // "map" is an instance of GMap3
                var numMarkers = 0;
                var latlngbounds = new google.maps.LatLngBounds();
                for (var key in markers) {
                    if (markers[key] && !toolsService.isEmpty(markers[key])) {
                        latlngbounds.extend(markers[key].position);
                        numMarkers++;
                    }
                }

                map.setCenter(latlngbounds.getCenter());
                if (numMarkers == 1) {
                    if ($scope.searchHistory && $scope.searchHistory.city) {
                        map.setZoom(boundariesByZone[$scope.searchHistory.city].zoom);
                    }
                    else {
                        map.setZoom(15);
                    }
                } else {
                    map.fitBounds(latlngbounds);
                }
            }

            function updatePackageMap(type, idx) {
                $timeout.cancel($scope.promise);
                $scope.promise = $timeout(function () {

                    if (type == 'origin' && !$scope.validatePickupAddress()) {
                        removeMarker('origin');
                        $scope.selectedPickup.adr = _.cloneDeep(emptyAddress);
                        return;
                    }
                    if (type == 'destination' && !validateDeliveriesAddress(idx)) {
                        removeMarker('destination', idx);
                        $scope.nestedAddresses[idx].adr = _.cloneDeep(emptyAddress);
                        return;
                    }

                    $scope.calculateSent = false;
                    $scope.formError = false;

                    var addressModel;
                    if (type === 'origin') {
                        addressModel = $scope.selectedPickup;
                    } else if (!isNaN(parseFloat(idx))) {
                        addressModel = $scope.nestedAddresses[idx];
                    }
                    return processAddress(addressModel, idx, type).then(function (adr) {
                        if (type === 'origin') {
                            $scope.selectedPickup.adr = _.cloneDeep(adr);
                            $scope.pickupError = false;
                        } else {
                            $scope.nestedAddresses[idx].adr = _.cloneDeep(adr);
                            $scope.errorsForm.nestedAddresses[idx].adr = false;
                        }
                        if (adr.latitude && adr.longitude) {
                            upsertMarker([adr.longitude, adr.latitude], type, idx);
                        }
                    }, function (errStatus) {
                        generateError(errStatus);
                    });
                }, 200);
            }

            function selectAddress(ad, type, idx) {
                if (!toolsService.isEmpty(ad.address)) {
                    if (idx !== undefined) {
                        $scope[type][idx].adr = _.cloneDeep(ad);
                        $scope[type][idx].comments = ($scope[type][idx].adr.comments) ? $scope[type][idx].adr.comments : "";
                        $scope[type][idx].addressView = $scope[type][idx].adr.address;
                        updatePackageMap('destination', idx);
                    } else {
                        $scope[type].adr = _.cloneDeep(ad);
                        $scope[type].comments = ($scope[type].adr.comments) ? $scope[type].adr.comments : "";
                        $scope[type].addressView = $scope[type].adr.address;
                        updatePackageMap('origin');
                    }
                }
            }

            function processAddress(addressModel, idx, type) {
                var deferred = $q.defer();
                var incomingAddress = "";
                var addressView = addressModel.addressView;
                var adrBundle;

                if (typeof addressView == 'string') {
                    adrBundle = _.pick(addressModel.adr, ['address', 'comments', 'latitude', 'longitude']); // var addressFieldsList = [ 'address', 'comments', 'latitude', 'longitude' ];
                    deferred.resolve(adrBundle);
                } else {
                    // if it comes with lat lng, we take profit of that and we don't need to do anything else :)
                    if (isGMapsAutocomplete(addressView)) {
                        var address = generateAddressFromComponents(addressView);
                        if (!address.address) {
                            deferred.reject("Invalid address " + type);
                        } else {
                            var lat = addressView.geometry.location.lat();
                            var lng = addressView.geometry.location.lng();
                            if (type === 'origin') {
                                $scope.pickupError = false;
                            } else {
                                $scope.errorsForm.nestedAddresses[idx].adr = false;
                            }
                            address.latitude = lat;
                            address.longitude = lng;
                            deferred.resolve(address);
                        }
                    } else {
                        // generated address joining street & number from components
                        adrBundle = generateAddressFromComponents(addressView);
                        incomingAddress = adrBundle.addressView;

                        geocodePromise({'address': incomingAddress}).then(function (results) {
                            if (results[0]) {
                                var complexAddress = results[0];
                                var address = generateAddressFromComponents(complexAddress);
                                if (!address.address) {
                                    deferred.reject("Invalid address " + type);
                                } else {
                                    var lat = complexAddress.geometry.location.lat();
                                    var lng = complexAddress.geometry.location.lng();
                                    if (type === 'origin') {
                                        $scope.pickupError = false;
                                    } else {
                                        $scope.errorsForm.nestedAddresses[idx].adr = false;
                                    }
                                    address.latitude = lat;
                                    address.longitude = lng;

                                    deferred.resolve(address);
                                }
                            } else {
                                deferred.reject("La dirección de recogida no es correcta, recuerda que debe contener el número y ser de Barcelona");
                            }
                        }, function (errStatus) {
                            deferred.reject("Lo sentimos pero no hemos encontrado esta dirección");
                        });
                    }
                }
                return deferred.promise;
            }

            function showLoginDialog() {
                $rootScope.$broadcast('showLoginDialog');
            }

            function waitGoogleMaps() {
                var deferred = $q.defer();
                var checkExist = setInterval(function() {
                    if ($scope.pageKey.name === "sendpackage") {
                        if (google.maps) {
                            clearInterval(checkExist);
                            deferred.resolve();
                        }
                    }
                    else {
                        clearInterval(checkExist);
                        deferred.reject();
                    }
                }, 100);
                return deferred.promise;
            }

            // EXECUTION
            $scope.delayedMouseOver = delayedMouseOver;
            $scope.addEmptyNestedAddress = addEmptyNestedAddress;
            $scope.deleteNestedAddress = deleteNestedAddress;
            $scope.checkPhone = checkPhone;
            $scope.validatePickupAddress = validatePickupAddress;
            $scope.checkSameAddress = checkSameAddress;
            $scope.calculate = calculate;
			$scope.updateHourList = updateHourList;
			$scope.selectAddress = selectAddress;

			$rootScope.$on("regenerateHistory", function () {
                getSearchHistory().then(function () {
                    if ($scope.selectedPickup.adr === undefined) {
                        generateMap();
                    }
                });
                $('.md-datepicker-input').attr('disabled', 'disabled');
            });

            $scope.$on('g-places-autocomplete-custom:select', function(place) {
                function placeThatNeedNumber(gmapsPlace) {
                    return  gmapsPlace.types.indexOf('point_of_interest') == -1;
                }

                // TODO: unify code
                var addressView = _.clone(place.targetScope.model);
                if($scope.mouseover) { // = pickup
                    $scope.selectedPickup.addressView = addressView;
                    $scope.pickupShowHistory = false;
                    if(!$scope.selectedPickup.adr) {
                        $scope.selectedPickup.adr = {};
                    }
                    $scope.pickupAdvice = !gmapsComponentExists($scope.selectedPickup,'street_number') && placeThatNeedNumber($scope.selectedPickup.addressView);
                    $timeout(function() {
                        updatePackageMap('origin');
                    });
                } else {
                    var nestedIdx = 0;
                    $scope.mouseForm.nestedAddresses.forEach(function(nadr, idx) {
                        if(nadr.mouseover) {
                            nestedIdx = idx;
                            $scope.nestedAddresses[idx].addressView = addressView;
                        }
                    });
                    $scope.fieldsForm.nestedAddresses[nestedIdx].showHistory = false;
                    if(!$scope.nestedAddresses[nestedIdx].adr) {
                        $scope.nestedAddresses[nestedIdx].adr = {};
                    }
                    $scope.advicesForm.nestedAddresses[nestedIdx].adr = !gmapsComponentExists($scope.nestedAddresses[nestedIdx],'street_number') && placeThatNeedNumber($scope.nestedAddresses[nestedIdx].addressView);

                    $timeout(function() {
                        updatePackageMap('destination', nestedIdx);
                    });
                }
            });

            waitGoogleMaps().then(function () {
                getSearchHistory().then(function () {
                    if ($scope.selectedPickup.adr === undefined) {
                        generateMap();
                    }
                });
                $('.md-datepicker-input').attr('disabled', 'disabled');
            });

            /*
			setTimeout(function() {
				$('.md-datepicker-input').removeAttr('disabled');
			},1000);
            */

            addEmptyNestedAddress();
			generateDatePickers();





			////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////





            /*  --CHECKOUT--  */
            // VARIABLES
			var checkout = undefined;
			$scope.backIsLoading = true;
            $scope.checkoutDisableButton = true;
            $scope.ask4ShargoDisableButton = false;
			$scope.firstTime = true;
			$scope.trans = "";
            $scope.promotionText = {
                prefix : "",
                text : "",
                suffix : "",
                extra: "",
                amount: ""
            };
            $scope.newCreditCard = {
                num: "",
                expirationDate: "",
                numBraintree: "",
                expirationDateBraintree: "",
                cvv: ""
            };

            $scope.formErrors = {
                check: {
                    number: false,
                    date: false,
                    cvv: false
                },
                text: {
                    number: "",
                    date: "",
                    cvv: ""
                }
            };
            $scope.creditCards = [];
            $scope.showCreditCards = false;
            $scope.indexDefault = 0;
            $scope.clientToken = undefined;
            $scope.showPopUpPromotion = false;
            $scope.promoCode = "";
            $scope.promoError = "";

            //FUNCTIONS
            function getFinalPrice(field, trans) {
                return (field) ? String(parseFloat((Math.round(field[trans] * 100) / 100)/1.21).toFixed(2)).replace('.',',') : '';
            }

            function getDiscountPrice(field1, field2, trans) {
                var senderPrice =  (field1) ? field1[trans] : '';
                var finalPrice = (field2) ? field2[trans] : '';
                return Math.round((finalPrice-senderPrice)*100)/100;
            }

            function getPromotionTextFormatted() {
                if(!toolsService.isEmpty($scope.promotion)) {
                    if($scope.promotion.type == 1) {
                        $scope.promotionText.prefix = $scope.promotion.amount;
                        $scope.promotionText.text = "promotion.amount-discount";
                    }else if($scope.promotion.type == 2){
                        $scope.promotionText.prefix = $scope.promotion.percentage * 100;
                        $scope.promotionText.text = "promotion.percentage-discount";
                    }else if($scope.promotion.type == 3){
                        $scope.promotionText.extra =  "promotion.until";
						$scope.promotionText.amount =  $scope.promotion.maxDiscount;
                        $scope.promotionText.text = "promotion.free-delivery";
                    }else if($scope.promotion.type == 4){
                        $scope.promotionText.suffix =  $scope.promotion.amount + "€";
                        $scope.promotionText.text = "promotion.fix-price";
                    }else if($scope.promotion.type == 5) {
                        if($scope.promotion.transport == 0) {
                            $scope.promotionText.suffix = $scope.promotion.amount + "€";
                            $scope.promotionText.text = "promotion.promo-5-bike";
                        } else if($scope.promotion.transport == 1) {
                            $scope.promotionText.suffix = $scope.promotion.amount + "€";
                            $scope.promotionText.text = "promotion.promo-5-moto";
                        } else if($scope.promotion.transport == 2) {
                            $scope.promotionText.suffix = $scope.promotion.amount + "€";
                            $scope.promotionText.text = "promotion.promo-5-car";
                        } else if($scope.promotion.transport == 3) {
                            $scope.promotionText.suffix = $scope.promotion.amount + "€";
                            $scope.promotionText.text = "promotion.promo-5-van";
                        }
                    }else if ($scope.promotion.type == "6") {
                        $scope.promotionText.prefix = "";
                        $scope.promotionText.text = "promotion.fix-transport";
                        $scope.promotionText.suffix = "";
                    }
                }
            }

            function initBraintree() {
                $scope.backIsLoading = true;
                $scope.checkoutDisableButton = true;
                if(checkout) {
                    checkout.teardown(function () {
                        checkout = undefined;
                        getClientToken();
                    });
                } else {
                    getClientToken();
                }
            }

            function getClientToken()  {

                $http.get(Configuration.apiUrl + '/payments/clienttokenandcards', {
                    headers: {
                        'x-token': localStorage.getItem('xtoken'),
                        'x-userid': localStorage.getItem('userid')
                    }
                }).then(function successCallback(response) {
                    if ($scope.calculateSent) {
                        $scope.formError = false;
                        $scope.isWhitelist = response.data.whitelist;
                        if ($scope.isWhitelist) {
                            $scope.ask4ShargoDisableButton = false;
                            $scope.showCreditCards = false;
                        }
                        $scope.indexDefault = 0;
                        $scope.clientToken = response.data.clientToken;
                        $scope.calculateSent = true;
                        $scope.calculateDisableButton = false;
                        $scope.backIsLoading = false;
                        $scope.checkoutDisableButton = false;
                        $scope.firstTime = false;
                        var button = document.querySelector('#order-a-shargo-button');

                        braintree.dropin.create({
                            authorization: $scope.clientToken,
                            vaultManager: true,
                            container: '#braintree-dropin-container'
                        }, function (createErr, instance) {
                            button.addEventListener('click', function () {
                                if ($scope.isWhitelist) {
                                    executeAsk4Shargo();
                                } else {
                                    instance.requestPaymentMethod({threeDSecure: {challengeRequested: true}}, function (requestPaymentMethodErr, payload) {
                                        // Submit payload.nonce to your server
                                        console.log('Payment nonce', payload);
                                        $scope.ask4ShargoDropIn(payload.nonce);
                                    });
                                }
                            });
                        });
                    }
                }, function errorCallback(err) {
                    $scope.calculateSent = false;
                    generateError(err.data.message);
                    $scope.calculateDisableButton = false;
                    $scope.firstTime = false;
                });
            }

            function clickPromotion() {
                $rootScope.blur.sendpackageCheckoutPromotion = $rootScope.blur.sendpackageCheckoutPromotionForced = $scope.showPopUpPromotion = true;
            }

            function clickoutPromotion() {
				$rootScope.blur.sendpackageCheckoutPromotion = $scope.showPopUpPromotion = $rootScope.blur.sendpackageCheckoutPromotionForced;
				$rootScope.blur.sendpackageCheckoutPromotionForced = false;
			}

			function hidePromotion() {
				$rootScope.blur.sendpackageCheckoutPromotion = $rootScope.blur.sendpackageCheckoutPromotionForced = $scope.showPopUpPromotion = false;
			}
			function addPromotion() {
				if (!$scope.promoCode) {
					$scope.promoError = "profile.errors.promotion";
				}
				else {
					var params = {
						promoCode: $scope.promoCode.toUpperCase()
					};
					$http.post(Configuration.apiUrl + '/senders/promotions', params, {
						headers: {
							'x-token': localStorage.getItem('xtoken'),
							'x-userid': localStorage.getItem('userid')
						}
					})
						.then(function successCallback() {
							$rootScope.blur.sendpackageCheckoutPromotion = $rootScope.blur.sendpackageCheckoutPromotionForced = $scope.showPopUpPromotion = false;
						}, function errorCallback(data) {
							console.log("ERROR PROMOTION", data);
							$scope.promoError = "profile.errors.promotion";
						});
				}
			}

            function showNewCreditCardDialog() {
                if ($scope.$parent != null) {
                    $rootScope.blur.sendpackageCreditCard = true;
                    $scope.showNewCreditCard = true;
                }
            }

            function hideNewCreditCardDialog() {
                if ($scope.$parent != null) {
                    if ($scope.creditCards.length > 0) {
                        $scope.newCreditCard = {
                            num: "",
                            expirationDate: "",
                            numBraintree: "",
                            expirationDateBraintree: "",
                            cvv: ""
                        };
                    }
                    $rootScope.blur.sendpackageCreditCard = false;
                    $scope.showNewCreditCard = false;
                }
            }

            function autocompleteNumber(){
                var len = $scope.newCreditCard.num.length;
                if (previous.number.length < len) {
                    if(len == 5 || len == 10 || len == 15) {
                        //$scope.newCreditCard.num += $scope.newCreditCard.num.charAt(len - 1);
                    }
                    else if (len > 19) {
                    }
                }
                else {
                    if (len <= 19) {
                    }
                    if(previous.number.split(" ").join("") == $scope.newCreditCard.num.split(" ").join("")) {
                        $scope.newCreditCard.num = previous.number;
                    }
                }
                var numAux = $scope.newCreditCard.num.split(" ").join("");
                if (numAux.length === 16) {
                    $scope.newCreditCard.num = numAux;
                   // $scope.newCreditCard.num = [$scope.newCreditCard.num.slice(0, 5), $scope.newCreditCard.num.slice(5)].join(' ');
                   // $scope.newCreditCard.num = [$scope.newCreditCard.num.slice(0, 10), $scope.newCreditCard.num.slice(10)].join(' ');
                    //$scope.newCreditCard.num = [$scope.newCreditCard.num.slice(0, 15), $scope.newCreditCard.num.slice(15)].join(' ');
                }
                if(!/^\d*$/.test($scope.newCreditCard.num.split(" ").join(""))) {
                    $scope.newCreditCard.num = previous.number;
                }
                else {
                    previous.number = $scope.newCreditCard.num;
                }
            }

            function autocompleteDate() {
                var len = $scope.newCreditCard.expirationDate.length;
                if (previous.date.length <= len) {
                    if (len == 1 && $scope.newCreditCard.expirationDate.charAt(0) != "0" &&
                        $scope.newCreditCard.expirationDate.charAt(0) != "1") {
                        $scope.newCreditCard.expirationDate += $scope.newCreditCard.expirationDate.charAt(len - 1) + " / ";
                        $scope.newCreditCard.expirationDate = toolsService.replaceAt($scope.newCreditCard.expirationDate, 0, "0");
                    }
                    else if (len == 2) {
                        if ($scope.newCreditCard.expirationDate.charAt(0) == "1" &&
                            $scope.newCreditCard.expirationDate.charAt(1) != "0" &&
                            $scope.newCreditCard.expirationDate.charAt(1) != "1" &&
                            $scope.newCreditCard.expirationDate.charAt(1) != "2") {
                            $scope.formErrors.check.date = true;
                            $scope.formErrors.text.date = "send-package.checkout.date-incorrect";
                        }
                        else {
                            $scope.newCreditCard.expirationDate += " / ";
                        }
                    }
                    else if (len == 3) {
                        $scope.newCreditCard.expirationDate += "/ " + $scope.newCreditCard.expirationDate.charAt(len - 1);
                        $scope.newCreditCard.expirationDate = toolsService.replaceAt($scope.newCreditCard.expirationDate, 2, " ");
                    }

                    else if (len == 4) {
                        $scope.newCreditCard.expirationDate += " " + $scope.newCreditCard.expirationDate.charAt(len - 1);
                        $scope.newCreditCard.expirationDate = toolsService.replaceAt($scope.newCreditCard.expirationDate, 3, "/");
                    }
                    else if (len == 5) {
                        $scope.newCreditCard.expirationDate += $scope.newCreditCard.expirationDate.charAt(len - 1);
                        $scope.newCreditCard.expirationDate = toolsService.replaceAt($scope.newCreditCard.expirationDate, 4, " ");
                    }
                    else if (len > 7) {
                        $scope.formErrors.check.date = true;
                        $scope.formErrors.text.date = "send-package.checkout.date-incorrect";
                    }
                }
                else {
                    if (len <= 7) {
                        $scope.formErrors.check.date = false;
                    }
                    var newDateAux = $scope.newCreditCard.expirationDate.split(" ").join("");
                    newDateAux = newDateAux.split("/").join("");
                    var previousDateAux = previous.date.split(" ").join("");
                    previousDateAux = previousDateAux.split("/").join("");
                    if(newDateAux.length > 2 && previousDateAux === newDateAux){
                        $scope.newCreditCard.expirationDate = previous.date;
                    }
                }
                var dateAux = $scope.newCreditCard.expirationDate.split(" ").join("");
                dateAux = dateAux.split("/").join("");
                if (dateAux.length === 4) {
                    dateAux = [dateAux.slice(0, 2), " / ", dateAux.slice(2)].join('');
                    $scope.newCreditCard.expirationDate = dateAux;
                }
                if(!/^\d*( |( \/)|( \/ ))?\d*$/.test($scope.newCreditCard.expirationDate)) {
                    $scope.formErrors.check.date = true;
                    $scope.newCreditCard.expirationDate = previous.date;
                }
                else {
                    previous.date = $scope.newCreditCard.expirationDate;
                }
            }

            function autocompleteCVV() {
                if(!/^\d*$/.test($scope.newCreditCard.cvv)) {
                    $scope.newCreditCard.cvv = previous.cvv;
                }
                else {
                    previous.cvv = $scope.newCreditCard.cvv;
                }
            }

			function checkNewCreditCard() {
				$scope.formErrors = {
					check: {
						number: false,
						date: false,
						cvv: false
					},
					text: {
						number: "",
						date: "",
						cvv: ""
					}
				};
				$scope.newCreditCard.numBraintree = $scope.newCreditCard.num.split(" ").join("");
				$scope.newCreditCard.expirationDateBraintree = $scope.newCreditCard.expirationDate.split(" ").join("");
				if($scope.newCreditCard.numBraintree.length != 16) {
					$scope.formErrors.check.number = true;
					$scope.formErrors.text.number = "send-package.checkout.number-length-incorrect";
				}
				if($scope.newCreditCard.cvv.length != 3) {
					$scope.formErrors.check.cvv = true;
					$scope.formErrors.text.cvv = "send-package.checkout.cvv-incorrect";
				}
				if($scope.newCreditCard.expirationDateBraintree.length != 5) {
					$scope.formErrors.check.date = true;
					$scope.formErrors.text.date = "send-package.checkout.date-format-incorrect";
				}
				if ($scope.formErrors.check.number || $scope.formErrors.check.cvv || $scope.formErrors.check.date) {
					var date = new Date();
					var year = parseInt($scope.newCreditCard.expirationDateBraintree.substring(3,5));
					var month = parseInt($scope.newCreditCard.expirationDateBraintree.substring(0,2));;
					if (date.getFullYear()%100 > year) {
						$scope.formErrors.check.date = true;
						$scope.formErrors.text.date = "send-package.checkout.date-incorrect";
					}
					else if (date.getFullYear()%100 == year && date.getMonth() > month) {
						$scope.formErrors.check.date = true;
						$scope.formErrors.text.date = "send-package.checkout.date-incorrect";
					}
				}
				return $scope.formErrors.check.number || $scope.formErrors.check.date || $scope.formErrors.check.cvv;
			}

			function changeDefaultCard(newDefaultCard, index) {
				if (!newDefaultCard.default) {
					newDefaultCard.default = true;
					$scope.creditCards[$scope.indexDefault].default = false;
					$scope.indexDefault = index;
					$scope.backIsLoading = false;
					$scope.checkoutDisableButton = false;
				}
			}

			function addNewCreditCard() {
				if(!checkNewCreditCard()) {
					$scope.backIsLoading = true;
					$scope.checkoutDisableButton = true;
					var client = new braintree.api.Client({clientToken: $scope.clientToken});
					client.tokenizeCard({
						number: $scope.newCreditCard.numBraintree,
						expirationDate: $scope.newCreditCard.expirationDateBraintree,
						cvv: $scope.newCreditCard.cvv
					}, function (err, nonce) {
						if(err == null) {
							$http.post(Configuration.apiUrl + '/payments/createnewcard', {paymentNonce: nonce}, {
								headers: {
									'x-token': localStorage.getItem('xtoken'),
									'x-userid': localStorage.getItem('userid')
								}
							}).then(function (response) {
								response.data.default = true;
								if ($scope.creditCards.length > 0) {
									$scope.creditCards[$scope.indexDefault].default = false;
								}
								var aux = false;
								if ($scope.creditCards.length == 0) aux = true;
								$scope.creditCards.splice(0, 0, response.data);
								$scope.indexDefault = 0;
								$scope.hideNewCreditCardDialog();
								$scope.backIsLoading = false;
								$scope.checkoutDisableButton = false;
								if (aux) {
									executeAsk4Shargo();
								}
							}).catch(function(error){
								$scope.formErrors.check.number = true;
								$scope.formErrors.text.number = "send-package.checkout.card-incorrect";
								$scope.backIsLoading = false;
								$scope.checkoutDisableButton = false;
								$scope.ask4ShargoDisableButton = false;
							});
						}
						else {
							$scope.formErrors.check.number = true;
							$scope.formErrors.text.number = "send-package.checkout.card-incorrect";
							$scope.backIsLoading = false;
							$scope.checkoutDisableButton = false;
							$scope.ask4ShargoDisableButton = false;
						}
					});
				}
				else {
					$scope.ask4ShargoDisableButton = false;
				}
			}

			function ask4Shargo() {
				if(!$scope.ask4ShargoDisableButton) {
					$scope.ask4ShargoDisableButton = true;
					if(!$scope.isWhitelist && !$scope.creditCards.length > 0) {
						$scope.addNewCreditCard();
					}
					else {
					    if ($scope.isWhitelist) {
                            executeAsk4Shargo();
                        } else {
                            $http.post(Configuration.apiUrl + '/payments/changedefaultcard', {paymentNonce: $scope.creditCards[$scope.indexDefault].token}, {
                                headers: {
                                    'x-token': localStorage.getItem('xtoken'),
                                    'x-userid': localStorage.getItem('userid')
                                }
                            }).then(function(response){
                                console.log("SUCCES");
                                console.log($scope.indexDefault);
                                executeAsk4Shargo();
                            }).catch(function(error){
                                console.log("ERROR");
                                console.log(error);
                                $scope.calculateSent = false;
                                generateError(error.data.message);
                                $scope.calculateDisableButton = false;
                                $scope.ask4ShargoDisableButton = false;
                            });
                        }
					}
				}
			}

            function ask4ShargoDropIn(paymentNonce) {
                if(!$scope.ask4ShargoDisableButton) {
                    $scope.ask4ShargoDisableButton = true;
                        if ($scope.isWhitelist) {
                            executeAsk4Shargo();
                        } else {
                            executeAsk4Shargo(paymentNonce);
                        }
                }
            }

			function executeAsk4Shargo (paymentnonce) {
				console.log("ASK4SHARGO!!!");
				var promotion = null;
				if (!toolsService.isEmpty($scope.promotion)) {
					promotion = $scope.promotion._id;
				}
				Analytics.trackEvent('dashboard', 'click', 'ask4Shargo', 10);
                Analytics.trackEvent('formulario', 'click', 'conversion', 11);
				var destBundle = [];
				$scope.nestedAddresses.forEach(function (nested) {
					var dBundle = {
						dropoffLocation: nested.adr,
						receptorName: nested.personName,
						receptorPhone: nested.personPhone,
						numPackages: nested.numPackages,
                        clientId: nested.clientId
					};
					dBundle.dropoffLocation.floorAndDoor = nested.floorAndDoor;
					destBundle.push(dBundle);
				});

				var selectTransport = {
					bike: 0,
					moto: 1,
					car: 2,
					van: 3
				};
				var newDeliveryBundle = {
					pickupLocation: $scope.selectedPickup.adr,
					transport: selectTransport[$scope.trans],
					paymentNonce: "",
					promotion: promotion,
					destinations: destBundle,
					orderDate: $scope.orderDate
				};
				if (paymentnonce){
				    newDeliveryBundle.paymentNonce = paymentnonce;
                }
				newDeliveryBundle.pickupLocation.comments = $scope.selectedPickup.comments;
                console.log("DELIVERY BUNDLE", newDeliveryBundle);
				$http.post(Configuration.apiUrl + '/delivers', newDeliveryBundle, {
					headers: {
						'x-token': localStorage.getItem('xtoken'),
						'x-userid': localStorage.getItem('userid')
					}
				}).then(function successCallback(response) {
					$scope.formError = false;
					$rootScope.dialogPushNotification = false;//OneSignal.isPushNotificationsSupported();
					var firstTimeKey = localStorage.getItem('userid') + '-firstTime';
					var firstTime = $cookies.get(firstTimeKey);
					if(!firstTime || firstTime === "") {
						var now = new Date();
						$cookies.put(firstTimeKey, 'ok', {
							expires: new Date(now.getFullYear()+1, now.getMonth(), now.getDate())
						});
					}

                    $rootScope.mgm.invitate = response.data.inviteFriend;
					if(response.data.inviteFriend) {
					    $rootScope.clipboardTextButton = response.data.inviteFriend.substr(response.data.inviteFriend.indexOf("shargo.io"));
					}

					$rootScope.$emit('dashboardHeaderSelection', {});
					$location.path( $rootScope.url('dashboard') );
				}, function errorCallback(data) {
					$scope.ask4ShargoDisableButton = false;
					generateError(data.data.message);
				});
			}

			function updateTrans(trans) {
				$scope.backIsLoading = true;
				$scope.formError = false;
				$scope.trans = trans;
				$scope.checkoutDisableButton = true;

				if (trans == "bike") {
					$scope.transIcon = "bike";
				} else if (trans == "moto") {
					$scope.transIcon = "moto";
				} else if (trans == "car") {
					$scope.transIcon = "car";
				} else if (trans == "van") {
					$scope.transIcon = "van";
				}

				if($scope.firstTime) {
					initBraintree();
				}
				else{
					$scope.backIsLoading = false;
					$scope.checkoutDisableButton = false;
				}
			}

			function isActive(trans) {
				return trans === $scope.trans;
			}

            function back() {
                $scope.backIsLoading = true;
                $scope.checkoutIsReady = false;
                if($scope.checkout) {
                    $scope.checkout.teardown(function () {
                        $scope.checkout = undefined;
                        resetCheckoutValues();
                    });
                } else {
                    resetCheckoutValues();
                }
            }

            function resetCheckoutValues() {
                $scope.backIsLoading = false;
                $scope.calculateDisableButton = false;
                $scope.calculateSent = false;
                $scope.checkoutIsReady = true;
            }

            //EXECUTION
            $scope.getFinalPrice = getFinalPrice;
            $scope.getDiscountPrice = getDiscountPrice;
            $scope.showNewCreditCardDialog = showNewCreditCardDialog;
            $scope.hideNewCreditCardDialog = hideNewCreditCardDialog;
            $scope.autocompleteNumber = autocompleteNumber;
            $scope.autocompleteDate = autocompleteDate;
            $scope.autocompleteCVV = autocompleteCVV;
			$scope.changeDefaultCard = changeDefaultCard;
			$scope.addNewCreditCard = addNewCreditCard;
			$scope.ask4Shargo = ask4Shargo;
			$scope.ask4ShargoDropIn = ask4ShargoDropIn
			$scope.updateTrans = updateTrans;
			$scope.isActive = isActive;
            $scope.back = back;
            $scope.clickPromotion = clickPromotion;
            $scope.clickoutPromotion = clickoutPromotion;
            $scope.hidePromotion = hidePromotion;
            $scope.addPromotion = addPromotion;
            $scope.generateHourText = generateHourText;
    });
})();
